/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/partials/grid.module.scss';

const propTypes = {
    className: PropTypes.string,
    columns: PropTypes.number,
    children: PropTypes.node,
};

const defaultProps = {
    className: null,
    columns: 0,
    children: null,
};

const Grid = ({ className, columns, children }) => (
    <div
        className={classNames(styles.container, {
            [className]: className !== null,
            [styles[`columns${columns}`]]: columns > 0,
        })}
    >
        <div className={styles.grid}>
            {React.Children.map(children, (child, childIndex) => (
                <div className={styles.item} key={`child-${childIndex + 1}`}>
                    {child}
                </div>
            ))}
        </div>
    </div>
);
Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

export default Grid;
